<template>
    <div class="surgeons">
        <input type="text" v-model="search" placeholder="Search..." class="search-input"/>

        <div class="row surgeons">
            <div
                class="surgeon"
                v-for="surgeon in filteredSurgeons"
                :key="surgeon.id"
            >
                <div class="cover-image" :style="{ backgroundImage: `url('${surgeon.image}')` }"></div>
                <div class="surgeon__body">
                    <span class="bold">{{ surgeon.name }}</span>
                    <span>{{ surgeon.hospital }}</span>
                    <span>{{ surgeon.country }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
      defineComponent,
      ref,
      computed
    } from 'vue';

    export default defineComponent({
        name: 'SurgeonSearch',

        props: {
          surgeons: Array,
          default: []
        },

        setup (props) {
          const search = ref('');

          const filteredSurgeons = computed(() => {
            return (props.surgeons).filter(surgeon => {
              if (search.value === '') {
                return true;
              }

              const searchResult = search.value.toLowerCase();
              const name = surgeon.name.toLowerCase();
              const country = surgeon.country.toLowerCase();


              return name.includes(searchResult) || country.includes(searchResult);
            });
          })

          return {
            search,
            filteredSurgeons
          }
        },
    })
</script>

<style lang="scss" scoped>
.search-input {
    border: 1px solid #a3277b;
    background: #fff url("/dist/img/ico_search.svg") 15px no-repeat;
    padding-left: 50px;
    margin-bottom: 32px;
}

.cover-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 175px;
  width: 175px;
  margin-bottom: 32px;
}

.surgeons {
  justify-content: center;
}

.surgeon {
  height: 100%;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.surgeon__body {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.surgeon__body span:not(:last-of-type) {
  padding-bottom: 8px;
}

.bold {
  font-weight: 700;
}

@media screen and (min-width: 501px){
  .surgeons::after {
    content: "";
    display: block;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    background-color: white;
  }

  .surgeon {
    min-height: 375px;
    max-width: 50%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding: 32px 16px 0 16px;
  }
}

@media screen and (max-width: 991px){
  .surgeon__body {
    text-align: center;
  }
}

@media screen and (min-width: 992px){
  .surgeons {
    justify-content: flex-start;
  }

  .surgeon {
    max-width: 20%;
  }
}
</style>
